class DualListBoxIconDetails {
  constructor(public iconClass: string, public titleKey: string) {}
}
export default DualListBoxIconDetails;
